import { render, staticRenderFns } from "./BenefitTree.vue?vue&type=template&id=55642e73"
import script from "./BenefitTree.vue?vue&type=script&lang=js"
export * from "./BenefitTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports